import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
    '/(auth)/projects/$projectVersionId/re-inspections/pv-inverters',
)({
    component: RouteComponent,
    staticData: {
        theme: 'solar',
    },
});

function RouteComponent() {
    return <Outlet />;
}
